import { render, staticRenderFns } from "./TaskInput.vue?vue&type=template&id=65eb1bfd&"
import script from "./TaskInput.vue?vue&type=script&lang=js&"
export * from "./TaskInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports